module.exports = __webpack_public_path__ + "static/media/HCMM783.438f5e2e.jpg";